<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px">
        <el-row :span="24">
          <el-col :span="24">
            <el-form-item prop="areaName" label="区域名称">
              <el-input clearable v-model="formData.areaName" placeholder="请输入区域名称" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="itemList" label="检查项">
              <div class="row-wrap">
                <div style="display: flex; align-items: center; margin-bottom: 10px;"
                  v-for="(item, index) of formData.itemList" :key="index">
                  <el-input style="margin-right: 10px;" v-model="item.itemName" placeholder="请输入检查项名称" />
                  <el-button circle icon="el-icon-plus" type="primary" @click="addItem"></el-button>
                  <el-button circle icon="el-icon-delete" type="danger" @click="delItem(index)"></el-button>
                  <!-- <i class="el-icon-minus del-icon" @click="delItem(index)" v-if="formData.itemList.length > 1"></i> -->
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>
export default {
  name: 'AreaMangeAdd',
  data() {
    return {
      formData: {
        areaName: '', // 区域名称
        itemList: [] // 检查项列表
      },
      rules: {
        areaName: [
          { required: true, message: '请输入区域名称' }
        ],
        itemList: [{ required: true, type: 'array', min: 1, message: '请至少添加一个检查项' }]
      }
    }
  },
  created() {
    if (this.areaId) {
      this.loadData()
    } else {
      this.addItem()
    }
  },
  computed: {
    areaId() {
      return this.$route.query.areaId
    }
  },
  methods: {
    addItem() {
      this.formData.itemList.push({
        itemName: '' // 检查项名称
      })
    },
    delItem(index) {
      this.formData.itemList.splice(index, 1)
    },
    loadData() {
      this.$axios.get(this.$apis.wspb.selectPaFactoryAreaByAreaId, { areaId: this.areaId }).then(res => {
        this.formData = res
      })
    },
    submit() {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.wspb.insertPaFactoryArea
        if (this.areaId) {
          url = this.$apis.wspb.updatePaFactoryArea
        }
        this.$axios.post(url, this.formData).then(() => {
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.add-icon {
  font-size: 18px;
  color: #3458f9;
  cursor: pointer;
  font-weight: 600;

}

.del-icon {
  font-size: 18px;
  color: #f22d2d;
  cursor: pointer;
  font-weight: 600;
  margin-right: 14px;

}

.row-wrap {
  display: flex;
  flex-direction: column;
}
</style>
